import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  selectSelectedProject,
  selectSelectedProjectId,
} from 'store/projects/selectors/projectsSelectors';
import { selectCreateFirestopListAttributes } from '../selectors/firestop-documentation.selectors';
import { postCreateFirestopList } from '../services/post-create-firestop-list.service';

export const createFirestopList = createAsyncThunk(
  'firestopDocumentation/createFirestopList',
  async (_, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    const selectedProject = selectSelectedProject(getState());

    const draftAttributes = selectCreateFirestopListAttributes(getState());

    const listAttributes = {
      name: `${selectedProject.name}, palokatkodokumentaatio`,
      ...draftAttributes,
    };

    const createdListData = await postCreateFirestopList(
      selectedProjectId,
      listAttributes
    );

    return createdListData;
  }
);
